import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { from } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { CreateRoleCommand } from '../../../../core/api/models';
import { RolesService } from '../../../../core/api/services/roles.service';
import {
  DialogService,
  DialogStatus,
} from '../../../../core/services/dialog.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { MenuClaimDto } from './../../../../core/api/models/menu-claim-dto';
import { RoleControllerClaimsDto } from './../../../../core/api/models/role-controller-claims-dto';
import { UpdateRoleCommand } from './../../../../core/api/models/update-role-command';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { CustomClaimDto } from './../models/custom-claim-dto';
import { CustomMenuDto } from './../models/custom-menu-dto';
import {
  EditRoleConfirmationComponent,
  EditRoleConfirmationDto,
} from './edit-role-confirmation/edit-role-confirmation.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { PanelClaimsComponent } from "./panel-claims/panel-claims.component";
import { PanelMenusComponent } from "./panel-menus/panel-menus.component";

@Component({
    selector: 'app-roles-form',
    templateUrl: './roles-form.component.html',
    styleUrls: [`./roles-form.component.scss`],
    imports: [BaseFormModule, PanelClaimsComponent, PanelMenusComponent]
})
export class RolesFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  formPageConfig: FormPageConfig<RoleControllerClaimsDto> = {};

  // @ViewChild(PanelMenusComponent) panelMenusComponent: PanelMenusComponent;

  @Input() menusClaims: Array<CustomMenuDto>;

  selectedClaims: Array<number> = [];
  model: CreateRoleCommand = {};
  claims: Array<CustomClaimDto> = [];
  baseMenuClaims: Array<CustomMenuDto>;

  organizations;

  menuTitleSelected: string;

  isChangeStatus: number = 0;

  //#endregion

  constructor(
    protected currentService: RolesService,
    private dialogService: DialogService
  ) {
    super();
  }

  ngOnInit() {
    window.scroll(0, 0);
    this.getVocabs();
    this.initForm();
    this.initModel();
    this.changeFormValidations();
  }

  initModel() {
    try {
      if (this.formPageConfig.isEditMode) {
        this.model = Object.assign(
          {},
          {
            name: this.formPageConfig.editData.name,
            organizationIds: this.formPageConfig.editData.organizations.map(
              (item) => item.id
            ),
          }
        );
        this.baseMenuClaims = JSON.parse(
          JSON.stringify(this.formPageConfig.editData.menusClaims)
        );
        ConsoleService.info('model', this.model);

        const Timeout = setTimeout(() => {
          this.isChangeStatus += 1;
          clearTimeout(Timeout);
        }, 10);
      } else this.model = {};
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl('', [Validators.required]),
      organizationName: new FormControl(''),
    });
  }

  changeFormValidations() {
    try {
      if (this.formPageConfig.isEditMode)
        this.form.controls['organizationName'].disable();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  //#region Api

  //Create
  baseCreateApi(model: CreateRoleCommand) {
    this.loading = true;

    this.unSubs();

    this.currentService
      .rolesCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateRoleCommand) {
    this.unSubs();
    this.loading = true;

    this.currentService
      .rolesUpdatePut({ body: model, id: this.formPageConfig.editId })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onChangeClaimsStatus(claims: Array<CustomClaimDto>) {
    try {
      from(claims)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((claim) => {
          this.selectSimilarClaims(claim.id, claim.selected);
          this.isChangeStatus += 1;
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  selectSimilarClaims(claimId: number, isSelected) {
    try {
      const onSelectedSimilarClaim = (array: MenuClaimDto[]) =>
        array.forEach((item) => {
          if (item.claims.length)
            item.claims.forEach((claim) => {
              if (claim.id == claimId) claim.selected = isSelected;
            });
          if (item.subMenus.length) onSelectedSimilarClaim(item.subMenus);
        });

      onSelectedSimilarClaim(this.menusClaims);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  onSubmit() {
    if (!this.isSelectOrganizations()) return;

    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.loading) return;

    this.model.claimIds = [];
    this.model.claimIds = this.getSelectedClaims(this.menusClaims);

    this.checkCreateOrUpdate();
  }

  checkChangesInEditMode() {
    let deletedOrganizationNames: string[] = [];
    let deletedClaimsCount: number = 0;

    //Get deleted Organization Names
    this.formPageConfig.editData.organizations.forEach((organization) => {
      const isExist = this.model.organizationIds.includes(organization.id);
      if (!isExist) deletedOrganizationNames.push(organization.name);
    });

    // Get deleted Claims Count
    const oldSelectedClaimIds: number[] = this.getSelectedClaims(
      this.baseMenuClaims
    );
    oldSelectedClaimIds.forEach((claimId) => {
      const isExist = this.model.claimIds.includes(claimId);
      if (!isExist) deletedClaimsCount++;
    });

    // No changes
    if (!deletedOrganizationNames.length && !deletedClaimsCount) {
      this.baseUpdateApi(this.model);
      return;
    }

    // Show Warning ....

    const data: EditRoleConfirmationDto = {
      roleName: this.formPageConfig.editData.name,
      deletedClaimsCount: deletedClaimsCount,
      deletedOrganizationCount: deletedOrganizationNames?.length,
      deletedOrganizationNames: deletedOrganizationNames,
    };

    const modalResult = this.dialogService.openModal({
      component: EditRoleConfirmationComponent,
      data: data,
    });

    modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((confirm) => {
        if (confirm) this.baseUpdateApi(this.model);
      });
  }

  checkCreateOrUpdate() {
    if (this.loading || !this.form.valid) return;

    if (this.formPageConfig.isEditMode) this.checkChangesInEditMode();
    else this.baseCreateApi(this.model);
  }

  isSelectOrganizations(): boolean {
    let result: boolean = true;

    if (!this.model.organizationIds?.length) {
      result = false;
      this.dialogService.openDialog({
        title: 'common.error',
        message: 'messages.notSelectAnyOrganization',
        status: DialogStatus.error,
      });
    }

    return result;
  }

  getSelectedClaims(menuClaims: Array<CustomMenuDto>): number[] {
    try {
      // this.model.claimIds = [];

      let claimIds: number[] = [];

      const findSelectedClaims = (array: MenuClaimDto[]) =>
        array.forEach((item) => {
          if (item.claims.length)
            item.claims.forEach((claim) => {
              if (claim.selected == true) {
                const isExist = menuClaims.find((claimId) => {
                  return claimId == claim.id;
                });
                if (!isExist) claimIds.push(claim.id);
              }
            });
          if (item.subMenus.length) findSelectedClaims(item.subMenus);
        });

      findSelectedClaims(menuClaims);

      return claimIds;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }
}
